<template>
    <div>
        <b-nav-item-dropdown
            id="dropdown-grouped"
            variant="link"
            right
        >
            <template #button-content>
                <span class="ml-50 text-body">{{ flow }}</span>
            </template>
            <b-dropdown-item
                v-for="flowName in flows"
                @click="select(flowName)"
            >
                <span class="ml-50">{{ flowName }}</span>
            </b-dropdown-item>
        </b-nav-item-dropdown>
    </div>
</template>

<script>
import {BNavItemDropdown, BDropdownItem} from 'bootstrap-vue'

export default {
    components: {
        BNavItemDropdown, BDropdownItem
    },
    methods: {
        select(flow) {
            this.$store.dispatch('changeReceivedRequestFlow', flow);
        },
    },
    computed: {
        flows() {
            return Object.values(this.$store.state.request.received.flows)
        },
        flow() {
            return this.$store.state.request.received.defaultFlow;
        }
    }
}
</script>
